export const heroTaglines = [
  "We don't just implement AI. We recalibrate futures.",
  "Recalibrating what's possible. Delivering what's next.",
  "Recalibrating the impossible into inevitable.",
  "Some see data. We see destinies waiting to be recalibrated."
];